import React, { useRef, useState } from 'react'
import joel from '../assets/illustration-webp/joel-miasin.webp'
import alex from '../assets/illustration-webp/alex.webp'
import audioJoel from '../assets/audio/le-doux-parfum-de-la-science-joel.mp3'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter, faInstagram, faTiktok, faYoutube, faTwitch} from "@fortawesome/free-brands-svg-icons";

const Founders = () => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const handleJoelDoubleClick = async () => {
        if (!audioRef.current) return;
        
        try {
            if (isPlaying) {
                await audioRef.current.pause();
                audioRef.current.currentTime = 0;
                setIsPlaying(false);
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            
            await audioRef.current.play();
            setIsPlaying(true);
        } catch (error) {
            console.error('Erreur lors de la lecture:', error);
            setIsPlaying(false);
        }
    };
    
    return (
        <div className="founders-desc flex flex-col lg:flex-row justify-center items-center md:flex-row mt-10">
            <div className="founder-card flex flex-col items-center mx-4 my-8">
                <h3 
                    className="text-3xl font-semibold text-white" 
                >
                    Joel
                </h3>
                <img 
                    src={joel} 
                    alt="Image de Joel" 
                    onDoubleClick={handleJoelDoubleClick}
                />
                <p 
                    className="text-center text-lg text-gray-300 mt-4" 
                >
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi molestiae quaerat non, labore aliquam asperiores aspernatur exercitationem obcaecati illum accusantium. Nobis deserunt dignissimos autem, eligendi facere unde aliquam ipsa distinctio?
                </p>
                <div className='founders-socials'>
                    <ul>
                        <li>
                            <a href="https://x.com/JoelPostbad" target='blank'><FontAwesomeIcon icon={faXTwitter}/></a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/bmsjoel/" target='blank'><FontAwesomeIcon icon={faInstagram}/></a>
                        </li>
                        <li>
                            <a href="https://www.twitch.tv/bmsjoel" target='blank'><FontAwesomeIcon icon={faTwitch}/></a>
                        </li>
                    </ul>
                </div>
                <audio 
                    ref={audioRef} 
                    onEnded={() => setIsPlaying(false)}
                    preload="auto"
                    controls={false}
                >
                    <source src={audioJoel} type="audio/mpeg" />
                    Votre navigateur ne supporte pas l'élément audio.
                </audio>
            </div>
                
            <div className="founder-card flex flex-col items-center mx-4 my-8">
                <h3 
                    className="text-3xl font-semibold text-white" 
                >
                    Alex
                </h3>
                <img 
                    src={alex} 
                    alt="Image d'Alex" 
                />
                <p 
                    className="text-center text-lg text-gray-300 mt-4" 
                >
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi molestiae quaerat non, labore aliquam asperiores aspernatur exercitationem obcaecati illum accusantium. Nobis deserunt dignissimos autem, eligendi facere unde aliquam ipsa distinctio?
                </p>
                <div className='founders-socials'>
                    <ul>
                        <li>
                            <a href="https://x.com/AlexBemutated" target='blank'><FontAwesomeIcon icon={faXTwitter}/></a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/alexlawdevara/" target='blank'><FontAwesomeIcon icon={faInstagram}/></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Founders